import { Flex } from "@chakra-ui/react";
import { AttachmentFileCard } from "./AttachmentFileCard";
import { ROUTE_NAMES } from "@root/constants";

interface AttachmentFilesListProps {
  files: any[];
  pendingFiles?: any[];
  onRemove: (identifier: string) => void;
  pathname: string;
  showForDocumentIntegration?: boolean;
  attachLoading?: boolean;
  attachedFile?: any[];
}

/**
 * Component to render a list of attachment files
 */
export const AttachmentFilesList = ({
  files,
  pendingFiles = [],
  onRemove,
  pathname,
  showForDocumentIntegration = false,
  attachLoading = false,
  attachedFile = [],
}: AttachmentFilesListProps) => {
  const shouldShowFiles =
    pendingFiles?.length > 0 ||
    (files?.length > 0 && !pathname?.startsWith(ROUTE_NAMES.CHECKLIST_CHAT));

  const shouldShowDocumentIntegrationFiles =
    showForDocumentIntegration &&
    attachedFile?.length > 0 &&
    pathname?.startsWith(ROUTE_NAMES.DOCUMENT_INTEGRATION_CHATBOT);

  if (!shouldShowFiles && !shouldShowDocumentIntegrationFiles) {
    return null;
  }

  return (
    <>
      {shouldShowFiles && (
        <Flex width="100%" flexWrap="wrap" gap="6px">
          {/* Pending files (still processing) */}
          {pendingFiles?.map((file: any) => (
            <AttachmentFileCard
              key={file?.id}
              file={file}
              onRemove={onRemove}
              isLoading={file?.status === "processing"}
            />
          ))}

          {/* Already processed files */}
          {files?.map((file: any) => (
            <AttachmentFileCard
              key={file?.fileName || file?.docId || file?.id}
              file={file}
              onRemove={onRemove}
            />
          ))}
        </Flex>
      )}

      {shouldShowDocumentIntegrationFiles && (
        <Flex width="100%" flexWrap="wrap" gap="6px">
          {attachedFile?.map((file: any) => (
            <AttachmentFileCard
              key={file?.fileName || file?.docId}
              file={file}
              onRemove={onRemove}
              showCloseButton={!attachLoading}
              isLoading={attachLoading || file?.status === "processing"}
            />
          ))}
        </Flex>
      )}
    </>
  );
};
